import React, { useContext, useEffect } from 'react';
import { Camera, Id, Document, BankIcon, CompanyIcon, DirectorsIcon } from 'src/assets/images';
import { SalesforceContext } from 'src/context/salesforce-context';
import TealiumEvents from 'src/helpers/tealium-events';
import './error-summary.scss';

const mapIcon = (pageCategory) => {
  switch (true) {
    case pageCategory?.subStepName.toLowerCase().includes('selfie'):
      return Camera;
    case pageCategory?.subStepName.toLowerCase().includes('directors'):
      return DirectorsIcon;
    case pageCategory?.subStepName.toLowerCase().includes('bank'):
      return BankIcon;
    case pageCategory?.subStepName.toLowerCase().includes('personal'):
      return Id;
    case pageCategory?.subStepName.toLowerCase().includes('company'):
      return CompanyIcon;
    case pageCategory?.subStepName.toLowerCase().includes('business'):
      return CompanyIcon;
    default:
      return Document;
  }
};

const cardManager = (pageUpdates) =>
  Object.entries(pageUpdates).map(([, value]) => {
    const image = mapIcon(value);
    return (
      <section key={`single-card-${value.subStepName}`}>
        <img src={image} alt={value.subStepName + ' image'} />
        <aside>
          <h1 className="card-heading">{value.subStepName}</h1>
          <p className="card-subtext">{value.uiExplanation}</p>
        </aside>
      </section>
    );
  });

export const ErrorSummary = (props) => {
  const { merchant } = useContext(SalesforceContext);

  useEffect(() => {
    props.toggleNext(true);
    TealiumEvents.errorSummaryView();
  }, [props]);

  return (
    <article className="ErrorSummary">
      <h1 className="error-heading">
        Hi {merchant.contact.first_names}, we need you to update the following:
      </h1>
      <p className="error-subheading">
        Below is a list of the information needed to complete your application
      </p>
      <section>{cardManager(merchant.pageUpdates)}</section>
    </article>
  );
};
